import { render, staticRenderFns } from "./goIndex.vue?vue&type=template&id=d10bc260&scoped=true&"
import script from "./goIndex.vue?vue&type=script&lang=js&"
export * from "./goIndex.vue?vue&type=script&lang=js&"
import style0 from "./goIndex.vue?vue&type=style&index=0&id=d10bc260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10bc260",
  null
  
)

export default component.exports